
export const config = {
  toolbar: {
    items: [
      'heading', '|',
      'fontfamily', 'fontsize', '|',
      'alignment', '|',
      'fontColor', 'fontBackgroundColor', '|',
      'bold', 'italic', 'strikethrough', 'underline', 'subscript', 'superscript', '|',
      'link', '|',
      'outdent', 'indent', '|',
      'bulletedList', 'numberedList', 'todoList', '|',
      'code', 'codeBlock', '|',
      'blockQuote', '|',
      'undo', 'redo'
    ],
    shouldNotGroupWhenFull: true
  }
}



